/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NistCsfWizardCatalogControlDto } from './NistCsfWizardCatalogControlDto';
import {
    NistCsfWizardCatalogControlDtoFromJSON,
    NistCsfWizardCatalogControlDtoFromJSONTyped,
    NistCsfWizardCatalogControlDtoToJSON,
    NistCsfWizardCatalogControlDtoToJSONTyped,
} from './NistCsfWizardCatalogControlDto';

/**
 * Category group and its controls for the NIST CSF wizard
 * @export
 * @interface NistCsfWizardCatalogCategoryNodeDto
 */
export interface NistCsfWizardCatalogCategoryNodeDto {
    /**
     * UUID of the category group
     * @type {string}
     * @memberof NistCsfWizardCatalogCategoryNodeDto
     */
    categoryId?: string;
    /**
     * Display title for the category
     * @type {string}
     * @memberof NistCsfWizardCatalogCategoryNodeDto
     */
    categoryTitle?: string;
    /**
     * Controls in this category (slim fields only)
     * @type {Array<NistCsfWizardCatalogControlDto>}
     * @memberof NistCsfWizardCatalogCategoryNodeDto
     */
    controls?: Array<NistCsfWizardCatalogControlDto>;
}

/**
 * Check if a given object implements the NistCsfWizardCatalogCategoryNodeDto interface.
 */
export function instanceOfNistCsfWizardCatalogCategoryNodeDto(value: object): value is NistCsfWizardCatalogCategoryNodeDto {
    return true;
}

export function NistCsfWizardCatalogCategoryNodeDtoFromJSON(json: any): NistCsfWizardCatalogCategoryNodeDto {
    return NistCsfWizardCatalogCategoryNodeDtoFromJSONTyped(json, false);
}

export function NistCsfWizardCatalogCategoryNodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NistCsfWizardCatalogCategoryNodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'categoryTitle': json['categoryTitle'] == null ? undefined : json['categoryTitle'],
        'controls': json['controls'] == null ? undefined : ((json['controls'] as Array<any>).map(NistCsfWizardCatalogControlDtoFromJSON)),
    };
}

export function NistCsfWizardCatalogCategoryNodeDtoToJSON(json: any): NistCsfWizardCatalogCategoryNodeDto {
    return NistCsfWizardCatalogCategoryNodeDtoToJSONTyped(json, false);
}

export function NistCsfWizardCatalogCategoryNodeDtoToJSONTyped(value?: NistCsfWizardCatalogCategoryNodeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryId': value['categoryId'],
        'categoryTitle': value['categoryTitle'],
        'controls': value['controls'] == null ? undefined : ((value['controls'] as Array<any>).map(NistCsfWizardCatalogControlDtoToJSON)),
    };
}

